import styled from "styled-components";

export const TableWrapper = styled.div`
  margin-right: 42px;
  margin-left: 38px;
`;
